import React, { useCallback } from 'react';
import {
  EditTimeLagMonitorView,
  EditTimeLagMonitorViewProps,
  TimeLagMonitorEditFormValues,
} from './EditTimeLagMonitorView';
import { RouteComponentProps, useHistory, useLocation } from 'react-router';
import { patchApi, postApi } from 'util/backendapi/fetch';
import {
  TimeLagMonitor_PATCH,
  TimeLagMonitor_POST,
} from 'util/backendapi/types/Model';
import { useIsMounted } from 'util/hooks';
import { parseNumberParamFromRouterProps } from 'util/routing';
import { useGetApi } from 'hooks/use-get-api';
import { errorToString } from 'util/backendapi/error';

export function EditTimeLagMonitorScreen(props: RouteComponentProps) {
  const location = useLocation<{ name?: string }>();
  const history = useHistory();
  const isMounted = useIsMounted();

  const timeLagMonitorId = parseNumberParamFromRouterProps(
    props,
    'timeLagMonitorId',
    0
  );

  const initialEditingState = Boolean(
    new URLSearchParams(location.search).get('edit')
  );
  const backUrl = new URLSearchParams(location.search).get('backUrl');

  const [timeLagMonitorDetail, , , reloadTimeLagMonitorData] = useGetApi(
    timeLagMonitorId ? `/time-lag-monitors/${timeLagMonitorId}/` : null
  );

  const handleSubmit: EditTimeLagMonitorViewProps['onSubmit'] = useCallback(
    async (values: TimeLagMonitorEditFormValues) => {
      if (values.id) {
        const timeLagMonitor: TimeLagMonitor_PATCH = {
          ...values,
          mode: values.mode!,
        };
        await patchApi(`/time-lag-monitors/${values.id}/`, timeLagMonitor);

        if (isMounted()) {
          reloadTimeLagMonitorData();
        }
      } else {
        const newTimeLagMonitor: TimeLagMonitor_POST = {
          ...values,
          mode: values.mode!,
        };
        await postApi('/time-lag-monitors/', newTimeLagMonitor);

        if (isMounted()) {
          history.push('/time-lag-monitors/');
        }
      }
    },
    [history, isMounted, reloadTimeLagMonitorData]
  );

  const handleCancel: EditTimeLagMonitorViewProps['onCancel'] =
    useCallback(() => {
      if (backUrl) {
        history.push(backUrl);
      } else {
        history.push(`/users/`);
      }
    }, [history, backUrl]);

  const isLoading =
    (timeLagMonitorId && timeLagMonitorDetail.isLoading) || false;
  const errorMessage: string | null =
    (timeLagMonitorId && errorToString(timeLagMonitorDetail.error)) || null;

  const isNewTimeLagMonitor = timeLagMonitorId ? false : true;

  const timeLagMonitor = timeLagMonitorDetail.data;

  return (
    <EditTimeLagMonitorView
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      timeLagMonitor={timeLagMonitor}
      isLoading={isLoading}
      isNewTimeLagMonitor={isNewTimeLagMonitor}
      initialEditingState={initialEditingState || isNewTimeLagMonitor}
      errorMessage={errorMessage}
    />
  );
}
